import { Injectable } from '@angular/core';
import { MenuItemDef } from 'ag-grid-community';
@Injectable({
  providedIn: 'root',
})
export class TableUtilityService {
  /** Get sorting key on column sort click for AG Grid
   * @param rowParams
   * @returns sorted param
   */
  getSortingKey(rowParams) {
    let sortParams = '';
    rowParams.sortModel.forEach((model) => {
      let fieldName: any;
      if (model.colId.includes('.')) {
        fieldName = model.colId.split('.').join('__');
      } else {
        fieldName = model.colId;
      }
      if (model.sort == 'asc') {
        sortParams = `${fieldName}:1`;
      } else {
        sortParams = `${fieldName}:-1`;
      }
    });
    return sortParams;
  }

  /**
   * Copy headername
   */
  processHeaderForClipboard(params) {
    return params.column.colDef.headerName;
  }

  /** Processing copy clipboard mechanics for custom AG-Grid cells
   * @param params - copied table values
   * @returns new updated values for custom cells
   */
  processCellForClipboard(params) {
    let data: any;
    let headerName: string = '';

    if (params.node?.data && params?.column?.colDef?.headerName) {
      headerName = params.column.colDef.headerName;
      data = params.node.data;
    }

    if (headerName === 'Status') {
      if (data.isActive === true) {
        return 'Active';
      } else {
        return 'Inactive';
      }
    } else {
      return params.value;
    }
  }

  /**
   * List context menu for table right click options
   */
  getContextMenuItems(): (string | MenuItemDef)[] {
    let result: (string | MenuItemDef)[] = [
      'copy',
      'copyWithHeaders',
      'copyWithGroupHeaders',
      'separator',
      'csvExport',
      'excelExport',
    ];
    return result;
  }
}
